import Vue from 'vue'
import moment from 'moment'

export default {
    state: {
        crosswords: {},
    },
    getters: {
        crosswordForUnit: (state) => (unitId) => {
            if (!unitId || !state.crosswords[unitId]) {
                return null
            }

            return state.crosswords[unitId]
        },
    },
    mutations: {
        setCrosswordForUnit(state, { unitId, crossword }) {
            if (unitId == null || unitId === '') {
                return
            }
            Vue.set(state.crosswords, unitId, crossword)
        },
    },
    actions: {
        async termInCrossword(context, payload) {
            const { termId, unitId } = payload
            const needsUnit = context.getters.crosswordForUnit(unitId) === null
            if (needsUnit) {
                await context.dispatch('getCrossword', {unit_id: unitId})

            }
            const crossword = context.getters.crosswordForUnit(unitId)
            const clues = _.get(crossword, 'crossword_data.clues')

            if (!Array.isArray(clues)) {
                return false
            }

            return clues.find((clue) => clue.term_id === termId) !== undefined
        },
        async getCrossword(context, payload) {
            try {
                const {unit_id} = payload
                const response = await this._vm.axios.get('/api/units/crossword/' + unit_id)
                if (!response.data) {
                    throw new Error('No crossword data found')
                }
                const crossword = response.data
                if (crossword.vocab_data) {
                    crossword.vocab_data = _.orderBy(crossword.vocab_data, 'term')
                }

                context.commit('setCrosswordForUnit', {unitId: unit_id, crossword})
            } catch (e) {
                await context.dispatch('pushError', {
                    data: {
                        message: `Failed to load crossword: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            }
        },
        async saveCrossword(context, payload) {
            const {unit_id, json} = payload
            try {
                await this._vm.axios.post('/api/units/update/' + unit_id, {
                    crossword_data: json
                })
            } catch (e) {
                await context.dispatch('pushError', {
                    data: {
                        message: `Failed to save crossword: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            } finally {
                await context.dispatch('getCrossword', {unit_id})
            }
        },
        updateSeed(context, payload) {
            const { unit_id, seed } = payload
            const crossword = context.getters.crosswordForUnit(unit_id)
            crossword.crossword_data.seed = seed
            context.commit('setCrosswordForUnit', {unitId: unit_id, crossword})
        },
    }
}
